import Config from 'conf';
import Logger from 'data/common/Logger';
import bindSocketEvents from './binds';

export default socketMiddleware => {
    bindSocketEvents(socketMiddleware);
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);
    return {
        refreshBox: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let refreshBoxFeedback = args => {
                    if (fheCenter_mac === args.mactarget) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('boxinfos', refreshBoxFeedback);
                        const { time_diff: timeDiff, dns_resolv: dnsResolv, free_space: freeSpace, zway_status: zwaveStatus, version } = args;

                        if (
                            timeDiff === undefined ||
                            dnsResolv === undefined ||
                            freeSpace === undefined ||
                            zwaveStatus === undefined ||
                            version === undefined
                        ) {
                            Logger.debug(`Arguments manquants sur l'envent socket boxinfos : "${JSON.stringify(args)}"`);
                            return reject(new Error('empty_args'));
                        }
                        return resolve();
                    }
                };
                socketOn('boxinfos', refreshBoxFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('boxinfos', refreshBoxFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_long_socket_order);

                socketEmit('boxinfos', { mactarget: fheCenter_mac });
            });
        },
        updateBox: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let updateBoxFeedback = args => {
                    if (fheCenter_mac === args.mactarget) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('updateBoxFeedback', updateBoxFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('updateBoxFeedback', updateBoxFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('updateBoxFeedback', updateBoxFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_long_socket_order);

                socketEmit('updateBox', { mactarget: fheCenter_mac });
            });
        },
        restartBox: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let restartBoxFeedback = args => {
                    if (fheCenter_mac === args.mactarget) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('restartBoxFeedback', restartBoxFeedback);
                        if (args.success) return resolve();
                        return reject(new Error(args.error));
                    }
                };
                socketOn('restartBoxFeedback', restartBoxFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('restartBoxFeedback', restartBoxFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('restartBox', { mactarget: fheCenter_mac });
            });
        },
        startVpn: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let startVpnFeedback = args => {
                    if (fheCenter_mac === args.mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('vpnConnected', startVpnFeedback);
                        return resolve();
                    }
                };
                socketOn('vpnConnected', startVpnFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('vpnConnected', startVpnFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('startVpn', { mactarget: fheCenter_mac });
            });
        },
        stopVpn: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let stopVpnFeedback = args => {
                    if (fheCenter_mac === args.mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('vpnDisconnected', stopVpnFeedback);
                        return resolve();
                    }
                };
                socketOn('vpnDisconnected', stopVpnFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('vpnDisconnected', stopVpnFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('stopVpn', { mactarget: fheCenter_mac });
            });
        },
        enableZway: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let enableZwayFeedback = args => {
                    if (fheCenter_mac === args.box_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('enableZway', enableZwayFeedback);
                        if (args.res === 'success') return resolve(args.box_mac);
                        return reject(new Error());
                    }
                };
                socketOn('enableZway', enableZwayFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('enableZway', enableZwayFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('enableZway', { box_mac: fheCenter_mac });
            });
        },
        disableZway: function(fheCenter_mac) {
            return new Promise((resolve, reject) => {
                let disableZwayFeedback = args => {
                    if (fheCenter_mac === args.box_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('disableZway', disableZwayFeedback);
                        if (args.res === 'success') return resolve(args.box_mac);
                        return reject(new Error());
                    }
                };
                socketOn('disableZway', disableZwayFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('disableZway', disableZwayFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('disableZway', { box_mac: fheCenter_mac });
            });
        },
        changeUpgradeStatus: function(fheCenter_mac, action) {
            return new Promise((resolve, reject) => {
                let changeUpgradeStatusStatusFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('feedbackAutoUpgrade', changeUpgradeStatusStatusFeedback);
                        if (args.action && args.error === null) return resolve();
                        else reject(args.error);
                    }
                };
                socketOn('feedbackAutoUpgrade', changeUpgradeStatusStatusFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('feedbackAutoUpgrade', changeUpgradeStatusStatusFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('autoUpgrade', { fheCenter_mac, action });
            });
        }
    };
};



// WEBPACK FOOTER //
// ./environments/fhe/eventsSocket/Box/index.js